export default __webpack_public_path__ + "d09fe288211ae6847dcebd8fa66448e3.png";